const loginPlugin = {
    install: function (Vue, options) {
        Vue.prototype.$login = {
            async logout(msg, title) {
                let _confirmMsg = msg ? msg : "是否确认退出?";
                let _confirmOpts = Object.assign(
                    { logoutConfirm: true },
                    title ? { title: title } : {}
                );
                let _result = await options.dialog.confirm(_confirmMsg, _confirmOpts);
                if (_result.state) {
                    try {
                        await $.post('/api/Token/Logout');
                    }
                    catch (err) {
                        console.error(err);
                    }
                    options.router.refreshTo("/Login");
                }
            },
            unloginMsg() {
                let _dialog = options.dialog.get('unlogin');
                _dialog.show();
                _dialog.$on('gologin', function () {
                    options.router.refreshTo("/Login"); //此方式可避免Vue的Store等資料留存
                    _dialog.hide();
                });
            },
        };
    }
};

export default loginPlugin;